import React, { useEffect, useRef, useState } from "react";
import { Description, RedMainHeading } from "../../Global/GlobalText";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import "./JuryEntryListing.scss";
import {
  GreyBackgroundButton,
  GreyfilterButton,
  RedBackgroundButton,
} from "../../Global/GlobalButton";
import { SelectBorder } from "../../Global/GlobalFormElement";
import { IoSearchSharp } from "react-icons/io5";
import { LuFilter } from "react-icons/lu";
import { GlobalThirdTable } from "../../Global/GlobalThirdTable/GlobalThirdTable";
import { JuryTitleBar } from "../../Global/JuryTitleBar/JuryTitleBar";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { EXCHNAGE_URL, EXCHNAGE_URL_JUDGE } from "../../../Url/Url";
import { toast } from "react-toastify";
import { useLoading } from "../../LoadingContext";

export const JuryEntryListing = () => {

  const navigate = useNavigate()
  const location = useLocation()
  const token = localStorage.getItem("juryToken")
  const {  logoImg ,eventName, fName, lName, awardCat, eventIdd, queryParams, juryData, awardCatId, judgeId} = location.state || {};
  const [selectedAwardId, setSelectedAwardId] = useState(awardCatId || "");
  const [juryCategoryData , setJuryCategoryData] = useState([]);
  const [columns, setColumns] = useState([])
  const { setLoading } = useLoading(); 
  const prevAwardIdRef = useRef();

  
console.log(awardCatId,"token")
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const judgemail = searchParams.get('judgemail');
    const eventId = searchParams.get('eventId');
    const roundId = searchParams.get('roundId');
  
    if (!judgemail || !eventId || !roundId) {
      navigate('/404');
    }
  }, [location.search, navigate]);

  
  const [data, setData] = useState([

  ]);
  
  const handleRowClick = (row) => {
    console.log("Row clicked:", row);
  };

  useEffect(() => {
    if (
      selectedAwardId &&
      prevAwardIdRef.current !== selectedAwardId
    ) {
      prevAwardIdRef.current = selectedAwardId;
      console.log("Fetching Jury Data for Award ID:", selectedAwardId);
      getJuryData(eventIdd, selectedAwardId);
    }
  }, [selectedAwardId]);
  

  const getJuryData = async (eventIdd, selectedAwardId) => {
    try {
      setLoading(true); // Start loader
  
      const response = await axios.get(
        `${EXCHNAGE_URL_JUDGE}/fetchSubmissionsJudge1?eventId=${eventIdd}&awardId=${selectedAwardId}&roundId=${queryParams.roundId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      if (response.status === 200 && response.data.data.length > 0) {
        toast.success("Data Fetched Successfully");
        setJuryCategoryData(response.data.data);
      } else {
        toast.info("No Data Found for the Selected Category");
        setJuryCategoryData([]);
        setColumns([]);
        setData([]);
      }
    } catch (error) {
      toast.error("No Data is Available for this Category");
      navigate(`/jury-dashboard?${new URLSearchParams(queryParams).toString()}`);
      console.error(error, "Error");
      setJuryCategoryData([]);
      setColumns([]);
      setData([]);
    } finally {
      setLoading(false); 
    }
  };
  
  console.log(juryCategoryData); // Ensure submissionId is part of the response

  const handleScoreNavigation = (submission_id) => {
    if (!submission_id) {
      toast.error("Submission ID is missing!");
      return;
    }
  
    const queryString = new URLSearchParams({
      ...queryParams,
      submission_id, // Adding submissionId dynamically
    }).toString();
    
    navigate(`/jury-score-board?${queryString}`, {
      state: {
        logoImg,
        eventName,
        fName,
        lName,
        awardCat,
        eventIdd,
        juryData,
        selectedAwardId,
        queryParams,
        submission_id, 
        judgeId,
        awardCatId,
      },
    });
  };

  const handleScoreNavigation2 = (submission_id) => {
    if (!submission_id) {
      toast.error("Submission ID is missing!");
      return;
    }
  
    const queryString = new URLSearchParams({
      ...queryParams,
      submission_id, // Adding submissionId dynamically
    }).toString();
    
    navigate(`/jury-update-score-board?${queryString}`, {
      state: {
        logoImg,
        eventName,
        fName,
        lName,
        awardCat,
        eventIdd,
        juryData,
        selectedAwardId,
        queryParams,
        submission_id, 
        judgeId,
        awardCatId,
      },
    });
  };
  
  useEffect(() => {
    if (juryCategoryData.length > 0) {
      const excludedFields = ["eventId", "roundId", "awardId"];
  
      const dynamicColumns = Object.keys(juryCategoryData[0])
        .filter((key) => !excludedFields.includes(key))
        .map((key) => ({
          key,
          label: key
            .replace(/[-_]/g, " ")
            .replace(/\d+$/g, "")
            .trim()
            .replace(/\b\w/g, (char) => char.toUpperCase()),
        }));
  
      dynamicColumns.push({ key: "actions", label: "Actions" });
  
      const mappedData = juryCategoryData.map((item) => ({
        ...Object.fromEntries(
          Object.entries(item).filter(([key]) => !excludedFields.includes(key))
        ),
        actions: (
          <>
      {item.scoreStatus === "scored" ? (
        <RedBackgroundButton
          type="button"
          style={{ fontSize: "13px" }}
          onClick={() => handleScoreNavigation2(item.submission_id)}
        >
          Update
        </RedBackgroundButton>
      ) : (
        <RedBackgroundButton
          type="button"
          style={{ fontSize: "13px" }}
          onClick={() => handleScoreNavigation(item.submission_id)}
        >
          Score
        </RedBackgroundButton>
      )}
    </>
          
        ),
      }));
  
      setColumns(dynamicColumns);
      setData(mappedData);
    } else {
      setColumns([]);
      setData([]);
    }
  }, [juryCategoryData]);
  
  return (
    <div>
      <div className="juryentrylisting_div">
          <JuryTitleBar logoImg={logoImg} eventName={eventName} fName={fName} lName={lName} />
        <div className="juryentrylisting_white_bg">

          <div className="juryentrylisting_head">
            <RedMainHeading className="titlbar_head">
              Judging - Submission
            </RedMainHeading>

            <div className="juryentlist_icon_head">
              <MdOutlineKeyboardArrowLeft/>
              <Description>Back to Category Listing</Description>
            </div>
          </div>

          <div className="juryentrylisting_table_div">
          <SelectBorder
  onChange={(e) => setSelectedAwardId(e.target.value)}
  >
    <option value="" disabled>
      Select Category
    </option>
    {awardCat
      ? awardCat.map((award) => (
          <option
            key={award.awardId}
            value={award.awardId}
            selected={selectedAwardId === award.awardId} // Ensure selected awardId is reflected
          >
            {award.categoryName}
          </option>
        ))
      : null}
</SelectBorder>


            

            <div className="juryentrylisting_btn">
          
            <div className="juryentrylisting_search">
              <div className="juryentrylisting_icon">
                <IoSearchSharp/>
              </div>
              <div className="juryentrylisting_content">
                <input type="text" placeholder="Search here..." />
              </div>
            </div>

              <GreyfilterButton className="juryentrylisting_filter_icon">
                <LuFilter/>
                Filter
              </GreyfilterButton>
              
            </div>



          </div>


      <GlobalThirdTable
        data={data}
        columns={columns}
        onRowClick={handleRowClick}
      />


         <GreyBackgroundButton style={{width:"fit-content" , padding:"0.8rem 2rem"}} onClick={()=>navigate(`/jury-dashboard?${new URLSearchParams(queryParams).toString()}`)}>Back to Jury Dashboard</GreyBackgroundButton>


        </div>
      </div>
    </div>
  );
};
